import db from "./field_db"

// Write the CSRF token into IndexedDB so the service worker can read it.
// Called on each page load / controller connect.
export async function writeCsrfToken(token) {
  if (!token) return
  await db.session.put({ key: "csrf_token", value: token })
}

// Read the stored CSRF token. Returns null if not set.
export async function readCsrfToken() {
  const record = await db.session.get("csrf_token")
  return record?.value || null
}
